/* eslint-disable prettier/prettier */
import { clsx } from 'clsx'
import { PropertyValueMap,unsafeCSS } from 'lit'
import { property } from 'lit/decorators.js'
import { html } from 'lit/static-html.js'

import { DdsElement } from '../../../../internal/dds-hu-element'
import styles from '../../../icon/_styles/icon.scss?inline'

/**
 * `dap-ds-icon-arrow-up-line`
 * @summary An icon
 * @element dap-ds-icon-arrow-up-line
 * @title - ArrowsArrowUpLine
 * @group icon
 * @icontype arrows
 * 
 * @attribute {number} size - (optional) The width and height in pixels
 * @attribute {boolean} selected - (optional) Sets the icon color via the `fill` attribute
 * @attribute {string} accessibilityTitle - (optional) When using the icon standalone, make it meaningful for accessibility
 * @attribute {boolean} focusable - (optional) If `true` the icon can receive focus
 *
 * @csspart base - The main icon container.
 */
export default class ArrowsArrowUpLine extends DdsElement {
  static tagName = 'dap-ds-icon-arrow-up-line'

  /** (optional) The width and height in pixels */
  @property({ type: Number, reflect: true }) size? = 24
  /** (optional) Sets the icon color via the `fill` attribute */
  @property({ type: Boolean, reflect: true }) selected?: boolean = false
  /** (optional) When using the icon standalone, make it meaningful for accessibility */
  @property() accessibilityTitle?: string
  /** (optional) If `true` the icon can receive focus */
  @property({ type: Boolean }) focusable?: boolean = false

  static readonly styles = unsafeCSS(styles)

  protected firstUpdated(_changedProperties: PropertyValueMap<any> | Map<PropertyKey, unknown>): void {
    super.firstUpdated(_changedProperties)

    this.classList.add('dap-ds-icon')
  }

  render() {
    return html`
      <svg
        part="base"
        class=${clsx('icon', 'dap-ds-icon-arrow-up-line')}
        xmlns="http://www.w3.org/2000/svg"
        width=${this.size}
        height=${this.size}
        viewBox="0 0 24 24"
        tabindex=${this.focusable ? 0 : -1}
        aria-hidden=${this.ariaHidden ?? 'true'}>
        ${this.accessibilityTitle
          ? html`<title>${this.accessibilityTitle}</title>`
          : null}
        <g part="container">
          <g>
            <path d="M13 7.828V20h-2V7.828l-5.364 5.364-1.414-1.414L12 4l7.778 7.778-1.414 1.414z"></path>
          </g>
        </g>
      </svg>
    `
  }
}
